import { Spin } from "antd";
import { Loading3QuartersOutlined } from "@ant-design/icons";

const antIcon = <Loading3QuartersOutlined spin />;

type loginProps = {
  loading: boolean;
  children: React.ReactNode;
};

const LoginTemplate = (props: loginProps) => {
  const { loading, children } = props;

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <main className="mainLogin">
        <div className="twoColumn">
          <div className="leftLogin">
            <div className="loginWrapper">{children}</div>
          </div>
          <div className="rightLogin">
            <div
              className="rightLoginImg"
              style={{ backgroundImage: "url(/images/login/login-bg.svg)" }}
            />
          </div>
        </div>
      </main>
    </Spin>
  );
};

export default LoginTemplate;
